import React from "react";
import { Page } from "components/common";
import { Row, Col, Nav } from "reactstrap";
import { HoverCard } from "components";

import subs from "assets/images/subscription-icon.svg";
import app from "assets/images/integrate.svg";
import lang from "assets/images/custodies-icon.svg";
import settings from "assets/images/setting-icon.svg";
import promocode from "assets/images/connect.svg";
import hr from "assets/images/hr.svg";
import { useTranslation } from "react-i18next";

const ManageSubscription = () => {

    const {t} = useTranslation()

    return (
  <Page title={t("Manage Subscriptions")} className="general-settings">
    <hr />
    <Row>
      <Nav>
        <Col md={6}>
          <HoverCard
            imgSrc={app}
            to={`/core/app`}
            title="Applications"
            description="Add, edit and delete the applications used in subscriptions."
          />
        </Col>
        <Col md={6}>
          <HoverCard
            imgSrc={lang}
            to={`/core/language`}
            title="Languages"
            description="Add, edit and delete the languages to use in subscriptions."
          />
        </Col>
        <Col md={6}>
          <HoverCard
            imgSrc={promocode}
            to={`/core/promocode`}
            title="Promo Code"
            description="Manage your promocodes, add seasonal, change expiry and more."
          />
        </Col>
        <Col md={6}>
          <HoverCard
            imgSrc={hr}
            to={`/core/modules`}
            title="Modules"
            description="View and manage your modules here like HR, E-invoicing and more."
          />
        </Col>
        <Col md={6}>
          <HoverCard
            imgSrc={subs}
            to={`/subscription/plan`}
            title="Subscription Plans"
            description="Add, update or remove your subscription plans accordingly."
          />
        </Col>
        <Col md={6}>
          <HoverCard
            imgSrc={settings}
            to={`/subscriptions_settings`}
            title="General Settings"
            description="Manage account and tax rates here, add or change receivable account."
          />
        </Col>
      </Nav>
    </Row>
  </Page>
)};

export default ManageSubscription;
